"use client";

import { GoogleAnalytics } from "@next/third-parties/google";
import Script from "next/script";
import {
  ConsentStatus,
  CookieConsent,
  hasAnalyticsConsent
} from "../lib/consent";

type AnalyticsGateProps = {
  consentStatus: ConsentStatus;
  preferences: CookieConsent;
  ready: boolean;
};

const analyticsEnabled = process.env.NEXT_PUBLIC_ANALYTICS_ENABLED === "true";
const gaId = process.env.NEXT_PUBLIC_GA4_ID;
const clarityId = process.env.NEXT_PUBLIC_CLARITY_ID;

export function AnalyticsGate({
  consentStatus,
  preferences,
  ready
}: AnalyticsGateProps): JSX.Element | null {
  const shouldLoad =
    ready &&
    consentStatus === "saved" &&
    hasAnalyticsConsent(preferences) &&
    analyticsEnabled;

  if (!shouldLoad) {
    return null;
  }

  return (
    <>
      {gaId && <GoogleAnalytics gaId={gaId} />}

      {clarityId && (
        <Script id="ms-clarity" strategy="afterInteractive">
          {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${clarityId}");
          `}
        </Script>
      )}
    </>
  );
}
